import { jsx as _jsx } from "react/jsx-runtime";
import { Alert, Form } from 'antd';
import { txt } from 'libs/i18n';
const AfterUploadWarning = ({ profiles }) => {
    var _a, _b;
    const form = Form.useFormInstance();
    const selectedProfile = Form.useWatch('transcriptionProfile', form);
    const selectedProfileTags = (_b = (_a = profiles.find((profile) => profile.profile === selectedProfile)) === null || _a === void 0 ? void 0 : _a.tags) !== null && _b !== void 0 ? _b : [];
    if (!selectedProfileTags.includes('after-upload')) {
        return null;
    }
    return _jsx(Alert, { message: txt('profileWarning'), type: "warning", showIcon: true });
};
export default AfterUploadWarning;
